module.exports = __webpack_public_path__ + "img/mejorubi2.0fb804d2.svg";